module.exports = __webpack_public_path__ + "img/help_icon_selected_mobile.80d96952.svg";